import { useId, useRef } from "react";
import styles from "./style.module.css";
import ParagraphText from "../ParagraphText";

export default function AppCheckbox({
  onClick,
  onChange,
  label,
  sublabel,
  ...rest
}) {
  const id = useId();
  const inputRef = useRef(null);
  const {
    className: inputClassName,
    onChange: onChangeFromRest,
    ...inputRest
  } = rest;

  const handleChange = (e) => {
    onChangeFromRest?.(e);
    onChange?.(e);
    onClick?.(e);
  };

  /** Label text / sublabel: native association unreliable with controlled + CSS; forward click to input */
  const handleLabelClick = (e) => {
    const input = inputRef.current;
    if (!input || input.disabled) return;
    if (e.target === input) return;
    e.preventDefault();
    input.click();
  };

  return (
    <div className={`checkboxMainBox ${styles.checkBoxMainBox}`}>
      <label className={styles.label} onClick={handleLabelClick}>
        <input
          ref={inputRef}
          id={id}
          type="checkbox"
          name="checkbox"
          className={[styles.input, inputClassName].filter(Boolean).join(" ")}
          {...inputRest}
          onChange={handleChange}
        />
        <ParagraphText className={styles.labelText}>
          <span>
            {label}
          </span>
          {sublabel && (
            <span className={styles.sublabel}>{sublabel}</span>
          )}
        </ParagraphText>
      </label>
    </div>
  );
}
